import Page from "../../../../modules/Core/Components/Page";
import templateDefault from "../../../templates/default/pages/world/about";

export default class About extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("About Konstantino")} | ${this.ucfirst("window-title")}`
    );
  }
}
